import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { Button } from "@/components/ui/button";

import { dates } from "@/lib/dates";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { cn } from "@/lib/utils";

// Day-stepping header for the task list.
export const DashboardTaskDayNav = ({
  day,
  onDayChange,
  variant = "compact",
}: {
  day: Date;
  onDayChange: (day: Date) => void;
  variant?: "compact" | "comfortable";
}) => {
  const isComfortable = variant === "comfortable";

  /* Handlers */
  const handlePreviousDay = () => {
    mixpanelUtils.trackButtonClick(
      "Previous task day",
      MIXPANEL_SCREENS.DASHBOARD,
    );
    onDayChange(dates.addLocalDays(day, -1));
  };

  const handleNextDay = () => {
    mixpanelUtils.trackButtonClick("Next task day", MIXPANEL_SCREENS.DASHBOARD);
    onDayChange(dates.addLocalDays(day, 1));
  };

  /* Render */
  const buttonClassName = cn(
    "shrink-0 text-slate-500 hover:text-slate-700",
    isComfortable ? "h-8 w-8" : "h-7 w-7",
  );
  const chevronClassName = isComfortable ? "h-4 w-4" : "h-3.5 w-3.5";

  const render = () => (
    <Row
      className={cn(
        "items-center gap-1",
        isComfortable ? "justify-start" : "justify-between",
      )}
    >
      <Button
        className={buttonClassName}
        onClick={handlePreviousDay}
        size="icon"
        type="button"
        variant="ghost"
      >
        <ChevronLeftIcon className={chevronClassName} />
      </Button>
      <Text
        className={cn(
          isComfortable
            ? "text-sm font-medium text-slate-700"
            : "text-xs font-semibold text-slate-600",
        )}
      >
        {dates.relativeDayLabel(day)}
      </Text>
      <Button
        className={buttonClassName}
        onClick={handleNextDay}
        size="icon"
        type="button"
        variant="ghost"
      >
        <ChevronRightIcon className={chevronClassName} />
      </Button>
    </Row>
  );

  return render();
};
